module.exports = __webpack_public_path__ + "img/nodata-placeholder@3x.62f0149e.png";